export default __webpack_public_path__ + "static/media/bg-788.e98dcecd.png";